// Plain ASCII letters only: the names are lower-cased into email addresses and
// LinkedIn handles as they are.
export const LAST_NAMES: readonly string[] = [
  'Adams',
  'Anderson',
  'Bailey',
  'Baker',
  'Bennett',
  'Brooks',
  'Brown',
  'Campbell',
  'Carter',
  'Clark',
  'Collins',
  'Cook',
  'Cooper',
  'Cox',
  'Davis',
  'Edwards',
  'Evans',
  'Flores',
  'Foster',
  'Garcia',
  'Gomez',
  'Gray',
  'Green',
  'Hall',
  'Harris',
  'Hernandez',
  'Hill',
  'Howard',
  'Hughes',
  'Jackson',
  'Johnson',
  'Jones',
  'Kelly',
  'Kim',
  'King',
  'Lee',
  'Lewis',
  'Lopez',
  'Martinez',
  'Miller',
  'Mitchell',
  'Moore',
  'Morgan',
  'Morris',
  'Murphy',
  'Nelson',
  'Nguyen',
  'Parker',
  'Patel',
  'Perez',
  'Peterson',
  'Phillips',
  'Ramirez',
  'Reed',
  'Rivera',
  'Roberts',
  'Robinson',
  'Rodriguez',
  'Rogers',
  'Sanchez',
  'Smith',
  'Stewart',
  'Taylor',
  'Thompson',
  'Torres',
  'Turner',
  'Walker',
  'Ward',
  'Watson',
  'White',
  'Williams',
  'Wilson',
  'Wright',
  'Young',
];

export const FIRST_NAMES: readonly string[] = [
  'Ahmed',
  'Aisha',
  'Amanda',
  'Andrew',
  'Anthony',
  'Ava',
  'Barbara',
  'Brian',
  'Carlos',
  'Chloe',
  'Daniel',
  'David',
  'Diego',
  'Elena',
  'Elizabeth',
  'Emily',
  'Emma',
  'Eric',
  'Ethan',
  'Fatima',
  'Grace',
  'Hannah',
  'Ivan',
  'James',
  'Jennifer',
  'Jessica',
  'John',
  'Joseph',
  'Joshua',
  'Karen',
  'Kevin',
  'Laura',
  'Liam',
  'Linda',
  'Lisa',
  'Lucas',
  'Maria',
  'Mark',
  'Mary',
  'Matthew',
  'Mei',
  'Melissa',
  'Mia',
  'Michael',
  'Michelle',
  'Nancy',
  'Nathan',
  'Noah',
  'Olivia',
  'Omar',
  'Patricia',
  'Paul',
  'Priya',
  'Rachel',
  'Raj',
  'Richard',
  'Robert',
  'Ryan',
  'Sarah',
  'Sofia',
  'Steven',
  'Susan',
  'Wei',
  'William',
  'Yuki',
];
